<template>
  <v-dialog :value="dialog" @input="$emit('update:dialog', $event)" max-width="460" scrollable>
    <v-card class="rounded-xl">
      <v-card-title class="subtitle-1 font-weight-bold">
        <v-icon left color="amber darken-2">mdi-folder-multiple-outline</v-icon>
        {{ titulo }}
      </v-card-title>
      <v-card-subtitle v-if="subtitulo" class="pt-1">{{ subtitulo }}</v-card-subtitle>

      <v-card-text style="max-height: 55vh">
        <div v-for="c in carpetas" :key="c.id" class="d-flex align-center">
          <v-checkbox
            v-model="marcadas"
            :value="c.id"
            :disabled="!!bloqueadas[c.id]"
            hide-details
            dense
            class="mt-1 flex-grow-1"
          >
            <template #label>
              <span>{{ c.nombre }}</span>
              <span class="text-caption grey--text ml-2">máx. {{ c.limite }}</span>
            </template>
          </v-checkbox>
          <v-tooltip v-if="bloqueadas[c.id]" left>
            <template #activator="{ on, attrs }">
              <v-icon small color="grey" v-bind="attrs" v-on="on">mdi-lock-outline</v-icon>
            </template>
            <span>{{ bloqueadas[c.id] }}</span>
          </v-tooltip>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$emit('update:dialog', false)">Cancelar</v-btn>
        <v-btn color="primary" depressed :loading="guardando" :disabled="soloAnadir && !marcadas.length" @click="$emit('guardar', [...marcadas])">
          {{ textoGuardar }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";

// Elegir carpetas del catálogo para varios armarios a la vez
export default {
  name: "DialogElegirCarpetas",
  props: {
    dialog: { type: Boolean, default: false },
    titulo: { type: String, default: "Carpetas" },
    subtitulo: { type: String, default: "" },
    seleccionadas: { type: Array, default: () => [] },
    // { id_carpeta: motivo } que no se pueden desmarcar (p. ej. tienen documentos)
    bloqueadas: { type: Object, default: () => ({}) },
    soloAnadir: { type: Boolean, default: false },
    textoGuardar: { type: String, default: "Guardar" },
    guardando: { type: Boolean, default: false },
  },
  data() {
    return { marcadas: [] };
  },
  computed: {
    ...mapState("armarios", ["carpetas"]),
  },
  watch: {
    dialog: {
      immediate: true,
      handler(abierto) {
        if (abierto) this.marcadas = [...this.seleccionadas];
      },
    },
  },
};
</script>
